import type { ReactNode } from 'react';
import { cn } from '../cn';

export interface NavItemProps {
  label: ReactNode;
  meta?: ReactNode;
  active?: boolean;
  onClick?: () => void;
  href?: string;
  className?: string;
}

/** Sidebar item: 32 px, 10 px padding, radius 7, 500 13px; active = line fill + fg; meta mono 10px .06em fg4. */
export function NavItem({ label, meta, active, onClick, href, className }: NavItemProps) {
  const cls = cn(
    'flex h-8 w-full items-center justify-between rounded-md border-0 px-2.5 text-left text-md font-medium',
    active ? 'bg-line text-fg' : 'bg-transparent text-fg3 hover:text-fg',
    className,
  );
  const inner = (
    <>
      <span>{label}</span>
      {meta ? <span className="meta text-fg4">{meta}</span> : null}
    </>
  );
  if (href)
    return (
      <a href={href} onClick={onClick} className={cls} aria-current={active ? 'page' : undefined}>
        {inner}
      </a>
    );
  return (
    <button type="button" onClick={onClick} className={cls} aria-current={active ? 'page' : undefined}>
      {inner}
    </button>
  );
}

/** Section label above a nav group: micro fg5, 4/10/8 padding. */
export function NavSection({ children }: { children: ReactNode }) {
  return <span className="micro px-2.5 pb-2 pt-1 text-fg5">{children}</span>;
}
